/* global dataLayer */

export const pushToDataLayer = data => {
  if (typeof dataLayer !== 'undefined') {
    dataLayer.push(data);
  }
};
